import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { LocalStorageService } from './local-storage.service';
import { BaseService } from './base.service';
import { CookieService } from 'ngx-cookie-service';

import { Constants }                            from '../models/Constants';
import UserSearch from '../models/UserSearch';
import { UtilityService } from './utility.service';
// import * as angular_constants from "../../../angular.json";

@Injectable({
    providedIn: 'root' // necessario per CookieService
})
export class UserService extends BaseService {

    // http options used for making API calls
    private httpOptions: any;

    // error messages received from the login attempt
    public errors: any = [];
    project_labels = "";

    constructor(
        private httpClient: HttpClient,
        private _localStorageService: LocalStorageService,
        private _cookieService: CookieService
    ) {
        super();
        this.httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };

            // var all_keys = Object.keys(angular_constants.projects);
        // this.project_labels = all_keys[0];
        this.project_labels      = Constants.PROJECT_LABEL;

        this.url_params["users"]            = "user/";
        this.url_params["whoami"]           = "user/whoami/";
        this.url_params["is_auth"]          = "user/isauthenticated/";
        this.url_params["update"]           = "user/:id/";
        this.url_params["delete"]           = "user/:id/";
        // this.url_params["logout"]           = "/authportal/web/oidc/logout";

    }

    login(user) {
        return this.httpClient
            .post(this.base_server_url + this.login_base_url, JSON.stringify(user), this.httpOptions)
            .pipe(timeout(5000))
            .pipe(map((response: any) => response));
    }

    getLoggedUser() {
        return JSON.parse(localStorage.getItem(this.project_labels + "_user_info"));
    }

    isLogged() {
        return this._cookieService.get("csrftoken") !== null && this._cookieService.get("sessionid") !== null && localStorage.getItem(this.project_labels + "_user_info") !== null;
        // return !UtilityService.empty(this._cookieService.get("csrftoken")) && !UtilityService.empty(this._cookieService.get("auth_portal_sessionid"));
    }

    isCsrfTokenSet()
    {
        // return this._cookieService.get("csrftoken") !== null && this._cookieService.get("sessionid") !== null &&
        //             this._cookieService.get("csrftoken") !== "" && this._cookieService.get("sessionid") !== "";
        return this._cookieService.get("csrftoken") !== null && this._cookieService.get("csrftoken") !== "";
    }

    isAnExternalLogging()
    {
        return this.isCsrfTokenSet() && localStorage.getItem(this.project_labels + "_user_info") === null;
    }

    isSuperuser() {
        var user_info = JSON.parse(localStorage.getItem(this.project_labels + "_user_info"));
        if (user_info['is_superuser'] !== null && user_info['is_superuser'] !== undefined) {
            return user_info['is_superuser'];
        }
        return false;
    }

    // oidcLogout()
    // {
    //     return this.httpClient.post(this.base_server_url + this.url_params["logout"], this.httpOptions).pipe(timeout(5000)).pipe(map((response: any) => response));
    // }

    // logout() {
    //     // localStorage.removeItem(this.project_labels + '_user_info');
    //     // sessionStorage.clear();
    //     // return this.httpClient.post(this.base_server_url + this.logout_base_url, this.httpOptions).pipe(timeout(5000)).pipe(map((response: any) => response));
        
    // }

    logout() {
        return this.httpClient.post(this.base_server_url + this.logout_base_url, this.httpOptions).pipe(timeout(5000)).pipe(map((response: any) => response));
    }

    storeCsrfToken(token) {
        this._cookieService.set('csrftoken', token);
    }

    storeUserData(data) {
        this._localStorageService.setWatchedLocalStorage(this.project_labels + "_user_info", JSON.stringify(data));
    }

    // getUsers(user_search)
    // {
    //     var params = user_search.getHttpParams();
    //     return this.httpClient.get<any>(this.getApiUrl() + this.url_params["users"],{ params }).pipe(map((response: any) => response));
    // }

    getUsers(user_search : UserSearch , per_page = null, page_number = null , procedure_info = null, serialize_filter = {}): Observable<any>
    {
        var params = this.buildSearchParams(user_search , per_page, page_number, procedure_info, serialize_filter);
        return this.httpClient.get<any>(this.getApiUrl() + this.url_params["users"],{ params }).pipe(map((response: any) => response));
    }

    createUser(user) : Observable<any>
    {
        return this.httpClient.post(this.getApiUrl() +  this.url_params["users"],
            { 
              "user"        : user
            } 
            ).pipe(map((response: any) => response))
    }

    updateUser(user) : Observable<any>
    {
        return this.httpClient.put(this.getApiUrl() +  this.url_params["update"].replace(":id",user.id),
            { 
              "user"        : user
            } 
            ).pipe(map((response: any) => response))
    }

    getUserInfo()
    {
        return this.httpClient.get<any>(this.getApiUrl() + this.url_params["whoami"],{ }).pipe(map((response: any) => response));
    }

    isAuthenticated()
    {
        return this.httpClient.get<any>(this.getApiUrl() + this.url_params["is_auth"],{ }).pipe(map((response: any) => response));
    }

    deleteUser(id)
    {
        return this.httpClient.delete(this.getApiUrl() + this.url_params["delete"].replace(":id",id),{ } ).pipe(map((response: any) => response))
    }

    logoutRedirect()
    {
        // document.href = this.logout_redirect;
    }

}
